const features = {
  nodaFiCheck: 'nodafi_check',
  survey: 'survey',
  externalOrganizations: 'external_organizations',
  insight: 'insight',
  procedures: 'procedures',
  purchaseOrders: 'purchase_orders',
  issueCategoryHierarchy: 'issue_category_hierarchy',
  duplicatePmsConfig: 'duplicate_pms_config',
  advancedInsights: 'advanced_insights',
  duplicateLocationConfig: 'duplicate_location_config',
  pmPlanner: 'pm_planner',
  goldenBroom: 'golden_broom',
  aiReports: 'ai_reports',
  archivedTickets: 'archived_tickets',
  integrationsTab: 'integrations_tab',
  procedureEntryStatsTableWeb: 'procedure_entry_stats_table_web',
  aiProcedureTemplateGenerator: 'ai-procedure-template-generator',
} as const

export type FeatureGateName = (typeof features)[keyof typeof features]

export default features
